module.exports = __webpack_public_path__ + "img/gszz7@2x.609191e4.png";